const glb = {
  endpoint_base_url: 'http://localhost:9090/',
  apikey: 'sLvw27562der5'
};
export let global_config = glb;